import React from "react";
import "./Loader.css";

const LoaderRing = ({ sm, exsm, md, sm_md }: any) => {
  return (
    <div
      className={` ${
        sm
          ? "Loadermain-sm"
          : md
          ? "Loadermain-md"
          : exsm
          ? "Loadermain-exsm"
          : sm_md
          ? "Loadermain-sm-md"
          : "Loadermain"
      } `}
    >
      <div className="inside"></div>
    </div>
  );
};

export default LoaderRing;
